import { Divider } from "native-base";

export default Divider;